import { useCallback, useEffect, useState } from 'react';

import $ from 'jquery';
import { useDispatch, useSelector } from 'react-redux';

import panelStyles from './Notification.module.css';
import { ModalSystemContent } from './types/types';
import { getNotification } from '../../store/slices/notificationSlice/action';
import { notificationSelector } from '../../store/slices/notificationSlice/notificationSlice';

export const useNotification = () => {
    const dispatch = useDispatch();
    const notificationsIds = useSelector(notificationSelector.selectIds);

    const [isOpen, setIsOpen] = useState(false);
    const [needFetch, setNeedFetch] = useState(true);
    const [isOpenSystem, setIsOpenSystem] = useState(false);

    const [systemModalContent, setSystemModalContent] = useState<ModalSystemContent>({
        header: '',
        date: '',
        content: '',
    });

    const onCloseModalSystem = useCallback(() => {
        setIsOpenSystem(false);
        setSystemModalContent({ header: '', date: '', content: '' });
    }, []);

    const onOpenModalSystem = useCallback((data: ModalSystemContent) => {
        setIsOpenSystem(true);
        setSystemModalContent(data);
    }, []);

    useEffect(() => {
        if (isOpen && needFetch) {
            dispatch(getNotification());
            setNeedFetch(false);
        }
    }, [isOpen]);

    useEffect(() => {
        const button = document.querySelector<HTMLElement>('[data-action="notification"]');
        const panelClass = panelStyles.Notification;

        const onOverLayClick = (event: MouseEvent) => {
            const tgt = event.target as HTMLElement;
            if (tgt.closest('[data-action="notification"]') || tgt.closest(`.${panelClass}`)) {
                return;
            }
            onClose();
        };
        document.addEventListener('click', onOverLayClick);

        const handleButtonClick = (event: MouseEvent) => {
            event.stopPropagation();
            if (isOpen) {
                onClose();
            } else {
                setIsOpen(true);
            }
        };
        if (button) {
            button.addEventListener('click', handleButtonClick);
        }

        return () => {
            document.removeEventListener('click', onOverLayClick);
            if (button) {
                button.removeEventListener('click', handleButtonClick);
            }
        };
        // const button = document.querySelector('[data-action="notification"]');
        //
        // const onOverLayClick = (event: MouseEvent) => {
        //     onClose();
        // };
        //
        // document.addEventListener('click', onOverLayClick);
        // const handleClick = () => {
        //     if (isOpen) {
        //         onClose();
        //     } else {
        //         setIsOpen(true);
        //     }
        // };
        //
        // if (button) {
        //     button.addEventListener('click', handleClick);
        // }
        //
        // return () => {
        //     document.removeEventListener('click', onOverLayClick);
        //
        //     if (button) {
        //         button.removeEventListener('click', handleClick);
        //     }
        // };
    }, [isOpen]);

    const onClose = () => {
        if (isOpen) {
            setIsOpen(false);
            // @ts-ignore
            const url = routable.getRoute('notificationsHasUnreadNotifications');

            fetch(url, {
                method: 'GET',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
            })
                .then((response) => response.json())
                .then((data) => {
                    if (!data.data.has_unread_notifications) {
                        $('[data-action="notification"]').removeClass('notification-active');
                    }
                });
        }
    };

    return {
        isOpen,
        onClose,
        isOpenSystem,
        systemModalContent,
        onCloseModalSystem,
        onOpenModalSystem,
        needFetch,
        notificationsIds,
    };
};
